 <template>
  <div class="logistics-detail">
    <el-form ref="form" label-width="150px">
      <el-card>
        <el-row class="form-title">基本信息</el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="计费规则名称">{{detailData.ruleName}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="编码">{{detailData.thirdCode}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="关联物流合同">{{detailData.contractId}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签订主体（货主）">{{detailData.signSubjectCustomerName}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="适用主体（货主）">{{detailData.applicableSubjectCustomerStr}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签订主体（承运商）">{{detailData.signSubjectCarrierName}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="适用主体（承运商）">{{detailData.applicableSubjectCarrierStr}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="内外贸业务">{{logisticsVal.BusinessTypeArr[detailData.ministryDomesticBusiness]}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="定价方式">{{logisticsVal.pricingWayArr[detailData.pricingWay]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="启用状态">{{logisticsVal.enabledArr[detailData.enabled]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="版本编码">{{detailData.code}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建时间">{{detailData.createTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="创建人">{{detailData.createdUserName}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="更新时间">{{detailData.updateTime}}</el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <el-row class="form-title">计费参数</el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="结算方式">{{logisticsVal.settlementTypeArr[detailData.settlementType]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结算节点">{{logisticsVal.settlementNodeArr[detailData.settlementNode]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="亏吨方式">{{logisticsVal.lossTypeArr[detailData.lossType]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="亏吨值">{{detailData.lossValue}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="结算周期">{{logisticsVal.settlementCycleArr[detailData.settlementCycle]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="有效期">{{detailData.expirationDate}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="币种">{{logisticsVal.currencyArr[detailData.currency]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="货物">{{detailData.goodsStr}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="是否集装箱">{{logisticsVal.yesOrNoArr[detailData.isContainer]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="箱型">{{logisticsVal.containerTypeArr[detailData.containerTypeRequirement]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="箱属">{{logisticsVal.containerArr[detailData.containerOwnerShip]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="费用是否限额度">{{logisticsVal.yesOrNoArr[detailData.isLimit]}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="最低费用">{{detailData.minFee}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="最高费用">{{detailData.maxFee}}</el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <el-row class="form-title">计费规则</el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="计费模式">{{logisticsVal.feeSetTypeArr[detailData.feeSetType]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="运输方式">{{detailData.transportMode && (Math.abs(detailData.transportMode)  === 5 ? detailData.multiModelStr : logisticsVal.transportArr[Math.abs(detailData.transportMode)])}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="计价类型">{{logisticsVal.pricingTypeArr[detailData.pricingType]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发货行政区">{{detailData.shipRegion}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="收货行政区">{{detailData.receRegion}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发货地">{{detailData.shipAddressName}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收货地">{{detailData.receAddressName}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="里程">{{detailData.realMileage}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="计价单位">{{logisticsVal.pricingUnitArr[detailData.pricingUnitName]}}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税率（%）">{{detailData.rate}}</el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item label="费用说明">{{detailData.operatorRemark}}</el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <el-row v-if="detailData.feeSetType === 2">
          <el-row class="form-title">单位计价</el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="含税单价">{{detailData.taxPrice}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="不含税单价">{{detailData.noTaxPrice}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="税额">{{detailData.price}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="销售单价（含税）">{{detailData.salePrice}}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="预估含税单价">{{detailData.estimateTaxPrice}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="市场参考价">{{detailData.marketPrice}}</el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <!-- <el-row v-if="detailData.feeSetType === 10">
          <el-row class="form-title">单维度阶梯计价</el-row>
          <el-row :gutter="10"  v-for="(item, index) in detailData.contentJsonStr[0].firstDimension.entries" :key="index">
            <el-col :span="6">
              <el-form-item label="计价单位区间">{{item.low}}{{symbolArr[item.lowUnit]}}计价单位{{symbolArr[item.highUnit]}}{{item.high}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="含税单价">{{item.taxPrice}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="不含税单价">{{item.noTaxPrice}}</el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="税额">{{item.value}}</el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row v-if="detailData.feeSetType === 11">
          <el-row class="form-title">双维度阶梯计价</el-row>
          <el-row :gutter="10" v-for="(item, index) in detailData.contentJsonStr" :key="index">
            <el-col class="col-title">阶段区间{{index + 1}}</el-col>
            <el-col :span="24">
              <el-form-item label="第一维度">{{logisticsVal.pricingUnitArr[item.firstDimension.unit]}}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="计价单位区间">{{item.firstDimension.entries[0].low}}{{symbolArr[item.firstDimension.entries[0].lowUnit]}}第一维度单位{{symbolArr[item.firstDimension.entries[0].highUnit]}}{{item.firstDimension.entries[0].high}}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="第二维度">{{logisticsVal.pricingUnitArr[item.secondDimension.unit]}}</el-form-item>
            </el-col>
            <el-row class="row-ml" v-for="(secondItem, secondIndex) in item.secondDimension.entries" :key="secondIndex">
              <el-col :span="6">
                <el-form-item label="计价单位区间">{{secondItem.low}}{{symbolArr[secondItem.lowUnit]}}计价单位{{symbolArr[secondItem.highUnit]}}{{secondItem.high}}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="含税单价">{{secondItem.taxPrice}}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="不含税单价">{{secondItem.noTaxPrice}}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="税额">{{secondItem.value}}</el-form-item>
              </el-col>
            </el-row>
          </el-row>
        </el-row> -->
      </el-card>
    </el-form>
    <el-row>
      <el-button @click="handleClose">返 回</el-button>
    </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import logisticsVal from '../../logisticsVal'

export default {
  name: 'pricingRulesDetail',
  components: { },
  data () {
    return {
      id: this.$route.query.id,
      detailData: { rules: [ { conditions: [] } ] },
      symbolArr: {
        1: '<',
        2: '<='
      },
      logisticsVal: logisticsVal
    }
  },
  computed: {
  },
  mounted () {
    console.log('[ this.$route.query ] >', this.$route.query)
    this.queryDetail()
  },
  methods: {
    ...mapActions(['getPricingRulesDetail']),
    queryDetail () {
      this.getPricingRulesDetail({ id: this.id }).then(res => {
        if (res.success) {
          this.detailData = res.data
        }
      })
    },
    handleClose () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.logistics-detail{
  /deep/ .el-form-item__label{
    text-align: left;
  }
  .el-card{
    margin-bottom: 10px;
  }
  .col-title{
    font-size: 15px;
    margin-bottom: 10px;
  }
  .form-title {
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 15px;
  }
  .row-ml{
    margin-left: 5px;
  }
}
</style>
